const CardCheckoutSections = {
  ORDER: 'order',
  PAYMENT: 'payment',
  COMPLETE: 'complete'
};

export default CardCheckoutSections;
